import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private httpClient: HttpClient) { }

  login(data: any) {
    return this.httpClient.post(environment.apiUrl + '/auth/login', data);
  }

  userSignup(data: any) {
    return this.httpClient.post(environment.apiUrl + '/auth/user/signup', data);
  }
  SproviderSignup(data: any) {
    return this.httpClient.post(environment.apiUrl + '/auth/service-provider/signup', data);
  }

  logout() {
    return this.httpClient.post(environment.apiUrl + '/auth/logout', {});
  }

  isAuthenticated() {
    return this.httpClient.get(environment.apiUrl + '/auth/is-authenticated');
  }

  refreshToken() {
    return this.httpClient.get(environment.apiUrl + '/auth/refresh-token');
  }

  me() {
    return this.httpClient.get(environment.apiUrl + '/auth/me');
  }

  updateUser(data: any) {
    return this.httpClient.patch(environment.apiUrl + '/auth/update-info', data);
  }

  ResetPasswordSendMail(data: any) {
    return this.httpClient.post(environment.apiUrl + '/auth/send-password-reset-token', data);
  }



  ResetPasswordCheckToken(data: any) {
    return this.httpClient.post(environment.apiUrl + '/auth/check-password-reset-token', data);
  }

  ResetPasswordWithToken(data: any) {
    return this.httpClient.patch(environment.apiUrl + '/auth/reset-password', data);
  }

  changePassword(data: any) {
    return this.httpClient.patch(environment.apiUrl + '/auth/change-password', data);
  }
  getGoogleRedirectUrl(user_type) {
    return this.httpClient.get('https://backend.dalel.sa/api/auth/google',{params:{user_type:user_type}});
  }
 

  
}
